import { application } from "@v2/app";
application.$mount("#app");
